import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55075628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cartao-cliente" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.Imagem,
      style: _normalizeStyle({ maxHeight: _ctx.height }),
      alt: _ctx.Nome,
      loading: "lazy"
    }, null, 12, _hoisted_2)
  ]))
}